import { parse, ParseResult } from 'papaparse';

export function parseCsv<T>(file: File): Promise<ParseResult<T>> {
  return new Promise((resolve, reject) => {
    parse(file, {
      worker: true,
      header: true,
      skipEmptyLines: true,
      complete: function (results: ParseResult<T>) {
        results.data = results.data.filter((row: any) => {
          return Object.keys(row).find(
            (key: string) => row[key]?.trim()?.length > 0,
          );
        });
        return resolve(results);
      },
      error: (error) => {
        return reject(error);
      },
    });
  });
}

export function downloadCsv(csv: string, filename: string): void {
  const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const csvURL = URL.createObjectURL(csvData);
  const dateTime = `${new Date().toLocaleDateString(
    'en-US',
  )} ${new Date().getTime()}`;
  const link = document.createElement('a');

  link.href = csvURL;
  link.setAttribute('download', `${filename} Edits ${dateTime}.csv`);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link?.parentNode?.removeChild(link);
}
